import { registerPlugin } from '@capacitor/core';
const MetaMapCapacitorUnwrapped = registerPlugin('MetaMapCapacitor', {});
const MetaMapCapacitor = {
    showMetaMapFlow: function (options) {
        const { metadata } = options;
        return MetaMapCapacitorUnwrapped.showMetaMapFlow(Object.assign(Object.assign({}, options), { metadata: Object.assign(Object.assign({}, metadata), { sdkType: "capacitor" }) }));
    },
};
export * from './definitions';
export { MetaMapCapacitor };
//# sourceMappingURL=index.js.map